import React from "react";
import "../Styles/Vision.css";

const Vision = () => {
  return (
    <>
       <div className="vision-image">
         <img src="./corporate/M&V.png " alt="" />
        </div>
    <div className="vision-page">

      <h1 className="vision-title">Vision &amp; Mission</h1>
      <div className="vision-grid">

        <div className="vision-card">
          <h2>Our Vision</h2>

          <p className="vision-desc">
           We aspire to lead the way in transforming India’s infrastructure with smart, sustainable solutions that empower communities and drive economic growth.
          </p>

          <h4>WE INVISION A FUTURE WHERE WE:</h4>

          <ul>
            <li>Drive sustainable growth in every project.</li>
            <li>Empower communities and transform India.</li>
            <li>Set new standards of quality and efficiency.</li>
            <li>Build a future-focused infrastructure ecosystem.</li>
            <li>Lead the infrastructure sector with innovative solutions.</li>
          </ul>
        </div>

        {/* Mission */}
        <div className="vision-card">
          <h2>Our Mission</h2>

          <p className="vision-desc">
           We are shaping the future with innovative infrastructure solutions and a commitment to quality, sustainability, and community empowerment.
          </p>

          <h4>WE ARE COMMITTED TO ACHIEVING OUR MISSION BY:</h4>

          <ul>
            <li>Creating value for all stakeholders</li>
            <li>Ensuring quality and timely execution</li>
            <li>Delivering innovative infrastructure solutions</li>
            <li>Promoting sustainable growth and development</li>
            <li>Fostering a culture of collaboration and teamwork</li>
          </ul>
        </div>
      </div>
    </div>

    </>
  );
};

export default Vision;
